import NavigationError from "@/errors/navigation-error";
import { useBllsBalanceQuery } from "@/hooks/use-blls-balance-query";
import useMeQuery from "@/hooks/use-me-query";
import usePermissions from "@/hooks/use-permissions";
import { FC, ReactNode } from "react";
import { Outlet } from "react-router";

const ActiveSubscriptionGuard: FC<{ children?: ReactNode }> = ({
  children,
}) => {
  const { data } = useMeQuery();
  const { data: balance } = useBllsBalanceQuery({
    fetchParams: {
      path: {
        address: data!.address!,
      },
    },
  });
  const { can } = usePermissions();

  if (
    balance[import.meta.env.VITE_CURRENCY_SYMBOL] ||
    can("skip-subscription")
  ) {
    throw new NavigationError("/");
  }

  return children ?? <Outlet />;
};

export default ActiveSubscriptionGuard;
